import { render } from "./AppMain.vue?vue&type=template&id=9d508876&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=9d508876&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=9d508876&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d508876"]])

export default __exports__